import React, { FunctionComponent } from 'react';

import { Spinner } from '@yandex-360/orb-components/dist/components/Spinner';

import { Island } from '../../island';
import css from './styles.css';

export const FallbackSection: FunctionComponent = () => (
    <Island className={css.sectionWrapper}>
        <Spinner size="xl" view="orb" progress />
    </Island>
);
